import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

import MarketplacesIQMobileSubnav from './MarketplacesIQMobileSubnav';

// molecules
import HeroWithVideo from '@molecules/HeroWithVideo';
import LoadingArea from '@molecules/LoadingArea';
import TrackPageView from '@tracking/TrackPageView';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import SectionHeader from '../../../_molecules/SectionHeader';

// atoms
import { ButtonOutlineLarge, SectionWrapperInner, SectionWrapperOuter } from '@styled';

// functionality
import useDocumentTitle from '@hooks/useDocumentTitle';
import { useScreenMinMd, useScreenSmDown } from '@hooks/useResponsive';
import useViewer from '@hooks/useViewer';

const HeaderContainer = styled.div`
    margin-bottom: 40px;
`;

const MarketplacesIQLandingPage = () => {
    const { viewer } = useViewer();
    const { documentTitle } = useDocumentTitle('Marketplaces IQ');
    const isScreenMinMd = useScreenMinMd();
    const isScreenSmDown = useScreenSmDown();

    if (!viewer) {
        return <LoadingArea />;
    }

    return (
        <ErrorHandler>
            <TrackPageView>
                <MarketplacesIQMobileSubnav />

                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <SectionHeader title={documentTitle.toUpperCase()} />

                        <HeaderContainer>
                            <HeroWithVideo
                                imageSrc="/assets/images/pattern-white.svg"
                                videoSrc="https://vimeo.com/806814817/442f666f24"
                            />
                        </HeaderContainer>

                        <div className="flex justify-content-center">
                            <div
                                className={classNames({
                                    'flex mt-2rem': isScreenMinMd,
                                    'mt-1rem text-center': isScreenSmDown,
                                })}
                            >
                                <div>
                                    <ButtonOutlineLarge
                                        as="a"
                                        href="https://www.narrpr.com/home?propertymode=commercial&action=maps&cbcode=usicsc-n&ssocode=usicsc-n&utm_source=ICSC-ICSC&utm_medium=deep-link-sso&utm_campaign=Dashboard"
                                        target="_blank"
                                    >
                                        Get Started
                                    </ButtonOutlineLarge>
                                </div>

                                <div className={classNames({ 'ml-1rem': isScreenMinMd, 'mt-0.5rem': isScreenSmDown })}>
                                    <ButtonOutlineLarge
                                        as="a"
                                        href="https://www.icsc.com/marketplacesiq"
                                        target="_self"
                                    >
                                        Learn More
                                    </ButtonOutlineLarge>
                                </div>
                            </div>
                        </div>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default MarketplacesIQLandingPage;
